import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    width: "23%",
    position: "fixed",
    top: 0,
    right: 0,
    zIndex: 1101,
    minHeight: 70,
    alignContent: "center",
    alignItems: "center",
    justifyContent: "flex-start",
    fontFamily: "Lato",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(16),
    color: "#284524",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
}));
